/* eslint-disable max-len */
/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	bookmarkData : [],
	feedData     : { active: [], archieved: [] },
	eventData    : [],
	feedLikeCmt  : { feedId: '', likes: [], comments: [], feedCmtId: '' }
};

export const newsfeedslice = createSlice({
	name     : 'newsfeed',
	initialState,
	reducers : {
		getUpdateBookmark : (state, action) =>
		{
			state.bookmarkData = action.payload;
		},
		getFeedData : (state, action) =>
		{
			state.feedData = { ...state.feedData, ...action.payload };
		},
		setEventsData : (state, action) =>
		{
			state.eventData = action.payload;
		},
		setFeedLikeCmt : (state, action) =>
		{
			state.feedLikeCmt = { ...state.feedLikeCmt, ...action.payload };
		},
		resetFeed()
		{
			return initialState;
		}
	}
});

export const { getUpdateBookmark, getFeedData, setEventsData, setFeedLikeCmt, resetFeed } = newsfeedslice.actions;
export default newsfeedslice.reducer;